import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, DatePicker, message } from 'antd';
import dayjs from 'dayjs';
import { useUpdatePortalProjectMutation } from '../../../redux/api/compassPortal';
import MetadataSchemaEditor from './MetadataSchemaEditor';

const ProjectSettingsModal = ({ open, onClose, project }) => {
    const [form] = Form.useForm();
    const [metadataSchema, setMetadataSchema] = useState([]);
    const [updateProject, { isLoading }] = useUpdatePortalProjectMutation();

    useEffect(() => {
        if (project && open) {
            form.setFieldsValue({
                project_name: project.project_name,
                kickoff_date: project.kickoff_date ? dayjs(project.kickoff_date) : null,
                delivery_date: project.delivery_date ? dayjs(project.delivery_date) : null,
                ingestion_start_date: project.ingestion_start_date ? dayjs(project.ingestion_start_date) : null,
                ingestion_end_date: project.ingestion_end_date ? dayjs(project.ingestion_end_date) : null,
            });
            setMetadataSchema(project.metadata_schema || []);
        }
    }, [project, open, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const payload = {
                projectId: project.project_id,
                project_name: values.project_name,
                kickoff_date: values.kickoff_date?.format('YYYY-MM-DD'),
                delivery_date: values.delivery_date?.format('YYYY-MM-DD'),
                ingestion_start_date: values.ingestion_start_date?.format('YYYY-MM-DD') || '',
                ingestion_end_date: values.ingestion_end_date?.format('YYYY-MM-DD') || '',
                metadata_schema: metadataSchema.filter((f) => f.key && f.label),
            };
            await updateProject(payload).unwrap();
            message.success('Project settings updated');
            onClose();
        } catch (err) {
            if (!err?.errorFields) message.error('Failed to save project settings');
        }
    };

    if (!project) return null;

    return (
        <Modal
            title="Project Settings"
            open={open}
            onOk={handleOk}
            onCancel={onClose}
            confirmLoading={isLoading}
            okText="Save"
            width={640}
            destroyOnClose
        >
            <Form form={form} layout="vertical" preserve={false}>
                <Form.Item name="project_name" label="Project Name" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
                <div style={{ display: 'flex', gap: 12 }}>
                    <Form.Item name="kickoff_date" label="Kick-off Date" style={{ flex: 1 }}>
                        <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item name="delivery_date" label="Delivery Date" style={{ flex: 1 }}>
                        <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                </div>
                <div style={{ display: 'flex', gap: 12 }}>
                    <Form.Item name="ingestion_start_date" label="Ingestion Start" style={{ flex: 1 }}>
                        <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item name="ingestion_end_date" label="Ingestion End" style={{ flex: 1 }}>
                        <DatePicker style={{ width: '100%' }} />
                    </Form.Item>
                </div>
            </Form>

            <div style={{ marginTop: 16 }}>
                <div className="cp-modal-section__label" style={{ marginBottom: 10 }}>
                    METADATA SCHEMA
                </div>
                <p style={{ fontSize: 12, color: 'var(--medium-light-grey-color)', marginBottom: 12 }}>
                    Define the metadata fields that appear when creating data sources in this project.
                </p>
                <MetadataSchemaEditor value={metadataSchema} onChange={setMetadataSchema} />
            </div>
        </Modal>
    );
};

export default ProjectSettingsModal;
